import ClosedByUserErrorClass from 'Helpers/classes/ClosedByUserErrorClass';
import { makeQueryablePromise } from 'Utils/promise';
import {
  SET_ALL,
  SET_PROPS,
} from './mutation-types';

let savedState = {};

export default {
  setCurrentModal({ commit, state, dispatch, getters }, { current, props }) {
    if (props?.temporary && state.current) Object.assign(savedState, state);
    // set props for modal
    dispatch('setProps', props);
    // set current modal
    commit(SET_ALL, { current });
    // if promise exist, do not create new one to save promise actual in place where modal was called
    if (state.modalPromise && state.modalPromise?.isPending?.()) return state.modalPromise;
    // create promise and set resolve and reject functions
    let modalPromise = new Promise((resolve, reject) => {
      commit(SET_ALL, { resolve, reject });
    }).catch((error) => {
      // closed by user error skipped by default if it not explicit set to false
      if (getters.props?.ignoreClosedByUserError === false || !(error instanceof ClosedByUserErrorClass)) {
        throw error;
      }
    });
    // this function is adding ability to get state of promise from promise
    modalPromise = makeQueryablePromise(modalPromise);
    // set promise to state to save it
    commit(SET_ALL, { modalPromise });
    // return promise
    return modalPromise;
  },
  setProps({ commit }, props) {
    // Do not set mouse event or etc as props
    // it happens when action to set some modal using in template without brackets
    if (!props || props instanceof Event) return;
    commit(SET_PROPS, props);
  },
  setCancelInvestmentModal({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalCancelInvestment', props });
  },
  setModalInvestmentDocs({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalInvestmentDocs', props });
  },
  setModalDocuSign({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalDocuSign', props });
  },
  setModalWhitepaperDownload({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalWhitepaperDownload', props });
  },
  setModalIdentityVerification({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalIdentityVerification', props });
  },
  setModalAccreditationStatus({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalAccreditationStatus', props });
  },
  setModalBeneficialOwners({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalBeneficialOwners', props });
  },
  setModalWallet({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalWallet', props });
  },
  setModalAdditionalDocumentsDownload({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalAdditionalDocumentsDownload', props });
  },
  setModalLinkBankAccount({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalLinkBankAccount', props });
  },
  setModalProfileAccreditation({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalProfileAccreditation', props });
  },
  setModalDisclaimerDisclosure({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalDisclaimerDisclosure', props });
  },
  setModalConfirm({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalConfirm', props });
  },
  setModalComingSoon({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalComingSoon', props });
  },
  setTaxDocumentsModal({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalTaxDocuments', props });
  },
  setModalFarmUpdates({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalFarmUpdates', props });
  },
  setModalInvestmentProfileDocuments({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalInvestmentProfileDocuments', props });
  },
  setModalFarmPreview({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalFarmPreview', props });
  },
  setModalAddInvestmentProfile({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalAddInvestmentProfile', props });
  },
  setModalFarmOwnerExtended({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalFarmOwnerExtended', props });
  },
  setModalAffiliateCheck({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalAffiliateCheck', props });
  },
  setModalMarketOfferCreate({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOfferCreate', props });
  },
  setModalMarketOfferCreateConfirm({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOfferCreateConfirm', props });
  },
  setModalMarketOnboarding({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOnboarding', props });
  },
  setModalMarketOfferBuyBidList({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOfferBuyBidList', props });
  },
  setModalMarketOfferSellBidList({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOfferSellBidList', props });
  },
  setModalMarketOfferSellBidConfirm({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOfferSellBidConfirm', props });
  },
  setModalMarketOfferBuyBidComplete({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOfferBuyBidComplete', props });
  },
  setModalMarketOfferBuyNow({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOfferBuyNow', props });
  },
  setModalMarketOnboardingStatus({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOnboardingStatus', props });
  },
  setModalMarketOfferBuyBid({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketOfferBuyBid', props });
  },
  setModalMarketFAQ({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalMarketFAQ', props });
  },
  setModalDetailInformationPaymentMethod({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalDetailInformationPaymentMethod', props });
  },
  setModalDocumentView({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalDocumentView', props });
  },
  setModalNetPromoterScore({ dispatch }, props) {
    return dispatch('setCurrentModal', { current: 'ModalNetPromoterScore', props });
  },
  closeModal({ commit, getters }) {
    const { props } = getters;
    if (savedState.current) {
      commit(SET_ALL, savedState);
    } else {
      commit(SET_ALL, {
        current: null,
        resolve: null,
        reject: null,
        modalPromise: null,
      });
    }
    savedState = {};
    // Timeout for clear props, because modal has close animation and text can blinking
    setTimeout(() => {
      // if props didn't changed, reset it
      if (props === getters.props) commit(SET_ALL, { props: {} });
    }, 500);
  },
};
